import type { APIData } from '../../types/APIData';
import type { BattleTest } from '../../types/Battle';
import type { BattleData } from '../../types/BattleData';
import type { WidgetProps } from '../../types/WidgetProps';
import { checkBattleCriteria, getBattleVariant } from '../setupBattle';

/**
 * Resolve the active battle variant and expose its feature overrides.
 */
export default (
  test: BattleTest | null,
  props: WidgetProps,
  models?: Record<string, number>,
  data?: APIData | Record<string, never>,
): BattleData => {
  // Don't utils battle on server or in server tests to avoid breaking tests and widget flashing
  // Setup the test if the criteria matches (e.g. widget type)
  if (test && checkBattleCriteria(test.criteria, props, models, data)) {
    const variant = getBattleVariant(test, props);

    return {
      battleFeatures: variant?.features,
      test,
      variant,
    };
  }

  return {} as BattleData;
};
